export enum WorkingGroupTypes {
  NONE = 0,
  SANITATION = 1,
  ELECTRICAL_INSTALATION = 2,
  ADMINISTRATION = 3,
  COMMON = 4
}
